import { useEffect } from 'react';
import { RadioGroup, useRadioState } from 'reakit';
import { useStore } from 'effector-react';
import { permit$, setPermit, validPostcode$ } from 'models/product';

import { Radio, Row, T8y } from 'ui';

import { ReactComponent as DocumentIcon } from 'assets/images/icons/document.svg';

import style from './permitSection.module.scss';

export const PermitSection = ({
  setIsPermitModalOpen,
  setSelectingDetails,
  productId,
  isTotalPriceLoading,
}) => {
  const permit = useStore(permit$);
  const validPostcode = useStore(validPostcode$);

  const radioPermit = useRadioState({ state: permit });

  useEffect(() => {
    setSelectingDetails((prevState) => ({
      ...prevState,
      permit: radioPermit.state || undefined,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [radioPermit.state]);

  useEffect(() => {
    if (validPostcode) {
      setPermit(radioPermit.state);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validPostcode, radioPermit.state]);

  useEffect(() => {
    if (!permit) {
      radioPermit.setState(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permit, productId]);

  return (
    <div className={style.permitSection}>
      <div className={style.permitSectionTitle}>
        <DocumentIcon height="24px" width="24px" />
        <T8y xsVariant="t1" color="wilkoBlack" bold>
          Do you need a permit?
        </T8y>
      </div>
      <div className={style.permitSectionWrapper}>
        <T8y mt mb3 variant="t2v1" color="wilkoGray">
          Placing the skip on a public highway requires a permit, which can take
          3-7 days to receive.{' '}
          <T8y
            as="span"
            variant="t2v1"
            color="wilkoBlack"
            asLink
            boldLight
            onClick={() => setIsPermitModalOpen(true)}
          >
            More details
          </T8y>
        </T8y>
        <RadioGroup
          {...radioPermit}
          aria-label="permit"
          className={style.permitOptionsWrapper}
        >
          <Radio
            {...radioPermit}
            text="Yes"
            value="yes"
            variant="t2v1"
            color="wilkoBlack"
            boldLight
            className={style.permitOption}
            circleClassName={style.permitOptionCircle}
            circleActiveClassName={style.permitActiveOptionCircle}
            disable={isTotalPriceLoading}
          />
          <Radio
            {...radioPermit}
            text="No"
            value="no"
            variant="t2v1"
            color="wilkoBlack"
            boldLight
            circleClassName={style.permitOptionCircle}
            circleActiveClassName={style.permitActiveOptionCircle}
            disable={isTotalPriceLoading}
          />
        </RadioGroup>
      </div>
    </div>
  );
};
